<script setup>
import { useI18n } from 'vue-i18n';
import { usePiiRedaction } from 'dashboard/composables/usePiiRedaction';

defineProps({
  signatures: { type: Array, default: () => [] },
  otps: { type: Array, default: () => [] },
});

defineOptions({ name: 'DetailVerificationCard' });

const { t } = useI18n();
const { redactPersonName } = usePiiRedaction();

function personName(item) {
  return item.user_details?.names || item.user_details?.name || 'Unknown';
}
</script>

<template>
  <div class="space-y-1.5">
    <div
      v-for="(item, index) in signatures"
      :key="'sig-' + index"
      class="flex items-center justify-between text-sm"
    >
      <span class="text-gray-900">{{
        redactPersonName(personName(item))
      }}</span>
      <span
        class="rounded-full px-2 py-0.5 text-xs font-medium"
        :class="
          item.signed
            ? 'bg-green-100 text-green-700'
            : 'bg-gray-100 text-gray-600'
        "
      >
        {{
          item.signed
            ? t('ARDHISASA.LAND_PROCESSES.LAND_REGISTRATION.SIGNED')
            : t('ARDHISASA.LAND_PROCESSES.LAND_REGISTRATION.NOT_SIGNED')
        }}
      </span>
    </div>
    <div
      v-for="(item, index) in otps"
      :key="'otp-' + index"
      class="flex items-center justify-between text-sm"
    >
      <span class="text-gray-900">{{
        redactPersonName(personName(item))
      }}</span>
      <span
        class="rounded-full px-2 py-0.5 text-xs font-medium"
        :class="
          item.verified
            ? 'bg-green-100 text-green-700'
            : 'bg-gray-100 text-gray-600'
        "
      >
        {{
          item.verified
            ? t('ARDHISASA.LAND_PROCESSES.LAND_REGISTRATION.VERIFIED')
            : t('ARDHISASA.LAND_PROCESSES.LAND_REGISTRATION.NOT_VERIFIED')
        }}
      </span>
    </div>
  </div>
</template>
